<template>
  <v-card class="mx-auto pb-4">
    <v-card-title class="d-flex flex-column">
      <h1>{{ $t("english_graduate.list_student") }}</h1>
    </v-card-title>
    <v-card width="97%" class="mx-auto pa-2 bborder" elevation="3">
      <v-row justify="center" class="mt-2">
        <v-col cols="6" class="text-left pl-6"
          ><h3>{{ $t("english_graduate.year") }}</h3>
          <v-autocomplete
            outlined
            dense
            v-model="select_year"
            :items="year_list"
            @change="update_year"
          ></v-autocomplete
        ></v-col>
        <v-col cols="6" class="text-left pr-6"
          ><h3>{{ $t("english_graduate.semester") }}</h3>
          <v-autocomplete
            outlined
            dense
            v-model="select_semester"
            :items="semester_list"
            @change="update_semester"
          ></v-autocomplete
        ></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-left px-6"
          ><h3>{{ $t("english_graduate.faculty") }}</h3>
          <v-autocomplete
            outlined
            dense
            v-model="faculty_id"
            :items="faculties"
            :item-text="
              (item) =>
                inlineTranslator({
                  th: item.NAME_TH,
                  en: item.NAME_EN,
                })
            "
            item-value="FACULTY_ID"
            @change="getEnglishStudentList"
          ></v-autocomplete
        ></v-col>
      </v-row>
      <div class="justify-content-center text-end" v-if="faculty_id !== null">
        <v-btn
          class="mr-3 mb-1"
          color="red darken-1"
          @click="refresh()"
          outlined
        >
          <v-icon class="my-auto mr-2">mdi-table-refresh</v-icon>
          refresh
        </v-btn>
      </div>
      <v-simple-table class="pb-5">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center"><h4>#</h4></th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.student_id") }}</h4>
              </th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.name") }}</h4>
              </th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.surname") }}</h4>
              </th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.append_date") }}</h4>
              </th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.check_status") }}</h4>
              </th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.approved_date") }}</h4>
              </th>
              <th class="text-center">
                <h4>{{ $t("english_graduate.approver") }}</h4>
              </th>
              <th class="text-center"><h4></h4></th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr v-for="(item, index) in students_all" :key="item.order">
              <td class="greattable">{{ index + 1 }}</td>
              <td class="greattable">{{ item.student_id }}</td>
              <td class="text-left greattable">{{ item.th_name }}</td>
              <td class="text-left greattable">{{ item.th_surname }}</td>
              <td class="greattable" v-html="dt(item.created_at)"></td>
              <td class="text-center greattable">
                <v-chip v-if="item.status_id === '1'" color="amber lighten-1"
                  ><v-icon left color="amber lighten-5">
                    mdi-dots-horizontal-circle </v-icon
                  >{{
                    inlineTranslator({
                      en: getTextByCodeEn(item.status_id),
                      th: getTextByCodeTh(item.status_id),
                    })
                  }}</v-chip
                >
                <v-chip v-if="item.status_id === '3'" color="red"
                  ><v-icon left color="red lighten-4"> mdi-close-circle </v-icon
                  >{{
                    inlineTranslator({
                      en: getTextByCodeEn(item.status_id),
                      th: getTextByCodeTh(item.status_id),
                    })
                  }}</v-chip
                >
                <v-chip v-if="item.status_id === '2'" color="green"
                  ><v-icon left color="green lighten-4">
                    mdi-check-circle </v-icon
                  >{{
                    inlineTranslator({
                      en: getTextByCodeEn(item.status_id),
                      th: getTextByCodeTh(item.status_id),
                    })
                  }}</v-chip
                >
              </td>
              <td class="greattable" v-html="dt(item.approved_at)"></td>
              <td class="greattable">{{ item.approver_id }}</td>
              <td class="text-center greattable">
                <v-btn
                  color="light-blue darken-1 white--text"
                  @click="goTo(item.student_id, item.version_id)"
                  >{{ $t("english_graduate.verify") }}</v-btn
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-card>
</template>
<script>
import genericProvider from "@/services/generic.provider.js";
import EnglishProvider from "@/services/english.provider.js";
const genericService = new genericProvider();
const EnglishService = new EnglishProvider();

import { inlineTranslator } from "@/helper/translator";
import {
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
export default {
  name: "EnglishSubmitList",

  data: () => ({
    select_year: null,
    select_semester: null,
    year_list: ["2567", "2568", "2569", "2570", "2571"],
    semester_list: ["1", "2", "3"],
    faculty_id: null,
    faculties: [],
    students_all: null,
    condition_th: {
      1: "รออนุมัติ",
      2: "ผ่าน",
      3: "ไม่ผ่าน",
    },
    condition_en: {
      1: "Pending approval",
      2: "Passed",
      3: "Not Passed",
    },
  }),
  methods: {
    dt,
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      this.loading = true;

      const faculties = await genericService.getFaculty();
      this.faculties = faculties.sort((a, b) => a.FACULTY_ID - b.FACULTY_ID);
      this.faculties.map((data) => {
        data.NAME_TH = `${data.PREFIX_NAME_TH}${data.FACULTY_NAME_TH}`;
        data.NAME_EN = `${data.PREFIX_NAME_EN} ${data.FACULTY_NAME_EN}`;
      });

      this.loading = false;
    },

    update_year() {
      this.select_semester = null;
      this.students_all = null;
      this.faculty_id = null;
    },

    update_semester() {
      this.students_all = null;
      this.faculty_id = null;
    },
    async refresh() {
      this.getEnglishStudentList();
    },
    getTextByCodeTh(code) {
      return this.condition_th[code] || "";
    },
    getTextByCodeEn(code) {
      return this.condition_en[code] || "";
    },

    async getEnglishStudentList() {
      this.loading = true;
      this.students_all = null;

      const data = await EnglishService.getEnglishStudentList(
        this.select_year,
        this.select_semester,
        this.faculty_id
      ).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      if (data) {
        this.students_all = data;
      }
      this.loading = false;
    },

    async goTo(student_id, version_id) {
      const url = this.$router.resolve({
        path: "/english_submit_verify",
        query: { std_id: student_id, version: version_id },
      }).href;
      window.open(url, "_blank");
    },
  },
  created() {
    this.fetch_data();
    this.getEnglishStudentList();
  },
};
</script>
<style scoped>
.greattable {
  border: none;
}
.bborder {
  border: 1px solid #000000;
  border-radius: 15px;
}
</style>
